/* eslint-disable @typescript-eslint/no-explicit-any */
import { evalCondition } from './conditions';

export type ExtractFieldsOptions = { addAllFields?: boolean };

/** Flattens the field tree (nested `fields` and `tabs`), keeping named fields only unless `addAllFields`. */
export function extractFields(formFields: any[] | null | undefined, options?: ExtractFieldsOptions): any[] {
  if (!formFields) return [];

  const fieldNames: any[] = [];

  function iterate(fields: any[] | null | undefined) {
    if (!fields) return;

    for (const field of fields) {
      if (field.name || options?.addAllFields) {
        fieldNames.push(field);
      }
      if (field.type !== 'ListItem' && field.type !== 'MultiNumericField') {
        iterate(field.fields);
      }
      iterate(field.tabs);
    }
  }

  iterate(formFields);
  return fieldNames;
}

/** Fields currently visible for `data`: conditions evaluated, `hidden` fields skipped. */
export function extractCurrentFields(fields: any[] | null | undefined, data: any, parentData?: any): any[] {
  if (!fields) return [];
  let fieldNames: any[] = [];
  for (const field of fields) {
    if (evalCondition(field.condition, data) && (!parentData || evalCondition(field.parentCondition, parentData)) && !field.hidden) {
      if (field.name || field.type === 'MultiNumericField' || field.type === 'WorkshopRegistrationV2' || field.type === 'TownsField') {
        fieldNames.push(field);
      }
      if (field.fields && field.type !== 'ListItem' && field.type !== 'MultiNumericField') {
        fieldNames = [...fieldNames, ...extractCurrentFields(field.fields, data, parentData)];
      }
      if (field.tabs) {
        fieldNames = [...fieldNames, ...extractCurrentFields(field.tabs, data, parentData)];
      }
    }
  }
  return fieldNames;
}

/** Visible fields that must be filled: `required`, plus types that always carry their own checks. */
export function extractRequiredFields(fields: any[] | null | undefined, data: any, parentData?: any): any[] {
  return extractCurrentFields(fields, data, parentData).filter(
    (f) =>
      (f.required ||
        f.type === 'ListItem' ||
        f.type === 'WorkshopRegistrationV2' ||
        f.type === 'RoomingField' ||
        f.type === 'CarbonFootprintTransportField' ||
        (f.type === 'RadioField' && f.allowMultiple && f.minCount)) &&
      !f.disabled,
  );
}
